import React, { useState, useEffect } from 'react';
import '../Styles/Feature.css';

const features = [
  'Protecting Your Privacy Is Our Mission.',
  'End-to-End Encryption, Built In.',
  'No ADs. No Tracking. We Dont Sell Data.',
  'Youre In Control.',
  'Cyphr Systems, Privacy & Simplicity Redefined.',
  '— powered by integrity.'
];

function Feature() {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState('');
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const fullText = features[index];

    let timeout;

    if (charIndex < fullText.length) {
      // Typing characters
      timeout = setTimeout(() => {
        setText(fullText.substring(0, charIndex + 1));
        setCharIndex(prev => prev + 1);
      }, 100);
    } else if (charIndex === fullText.length) {
      // Pause before starting to backspace
      timeout = setTimeout(() => {
        setCharIndex(prev => prev + 1); // Use +1 as a signal to start deleting
      }, 3000);
    } else if (charIndex > fullText.length && text.length > 0) {
      // Backspacing characters
      timeout = setTimeout(() => {
        setText(prev => prev.slice(0, -1));
      }, 50);
    } else if (charIndex > fullText.length && text.length === 0) {
      // Move to the next feature
      timeout = setTimeout(() => {
        setIndex((index + 1) % features.length);
        setCharIndex(0);
      }, 300);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, index, text]);

  return (
    <div className="feature-carousel">
      <p className="feature-text">{text}</p>
    </div>
  );
}

export default Feature;